import { Component, inject, NgZone, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { CrispService } from '@core/services/crisp.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly crispService = inject(CrispService);
  private readonly ngZone = inject(NgZone);

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.deferCrispUntilInteraction();
    }
  }

  private deferCrispUntilInteraction(): void {
    const events = ['scroll', 'click', 'touchstart', 'mousemove', 'keydown'] as const;
    const controller = new AbortController();

    const init = () => {
      controller.abort();
      this.ngZone.runOutsideAngular(() => this.crispService.initialize());
    };

    for (const event of events) {
      window.addEventListener(event, init, { once: true, passive: true, signal: controller.signal });
    }

    // Fallback: load after 10s if no interaction
    setTimeout(init, 10_000);
  }
}
